/*
 * @Author: 黄贺林
 * @Date: 2024-07-13 09:47:41
 * @LastEditTime: 2025-02-26 19:06:12
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */

import store from '@/store'
import router from '@/router'
import { accountSender } from '@/api/anycubic_axios';



let isInit = true
class Account {
  constructor(notifyCallback) {
    this.Logged = false;
    this.user_info_ = ''
    this.notify_set = false;
    this.notify_lock = false;  // 互斥锁
    this.loginPollingTimer = null;  // 轮询定时器
    this.status_notify(notifyCallback);
  }
  async status_notify (func) {
    if (this.notify_lock) {
      console.log("Another instance is already running.");
      return 1;
    }
    this.notify_lock = true;  // 加锁

    try {
      if (this.notify_set) {
        console.log("notify_set is true")
        return 0;
      }
      let that = this

      window.status_notify = (status, user_info) => {
        console.log('account status notify===================>', status, user_info)
        if (status == 1) {
          that.Logged = true;
          that.user_info_ = user_info;
        } else if (status == 0) {
          that.Logged = false;
          that.user_info_ = '';
        }
        func(status, user_info)
      }
      isInit = true
      const response = await accountSender.post("status_notify", { "script": 'window.status_notify' })
      console.log('status_notify', response)
      this.notify_set = response.data === 0;
      return response.data
    } finally {
      this.notify_lock = false;  // 确保解锁
    }
  }
  async login () {
    if (!this.Logged) {
      const response = accountSender.put("login", {})
      return response.data
    } else {
      return -1;
    }
  }
  async logout () {
    if (this.Logged) {
      const response = accountSender.put("logout", {})
      return response.data
    } else {
      return -1;
    }
  }
  async is_logined () {
    if (this.Logged) {
      return true;
    }
    const result = await accountSender.get('logged', { 'token': 3 })
    const data = result.data;
    if (data && data.status === 1) {
      this.user_info_ = data.user_info;
      this.Logged = true;
      console.log('is_logined', this.Logged)
    } else {
      isInit = false
    }
    return this.Logged;
  }
  async token () {
    if (!this.Logged) {
      return '';
    }
    const result = await accountSender.get('logged', { 'token': 3 })
    const data = result.data;
    if (data && data.status === 1) {
      return data.access_token;
    }
    return '';
  }
  async user_info () {
    return this.user_info_;
  }
  async user_token (type) {
    if (!this.Logged) {
      return '';
    }
    const result = await accountSender.get('logged', { 'token': 3 })
    const data = result.data;
    if (data && data.status === 1) {
      if (type === 1) {
        return data.login_token;
      } else if (type === 2) {
        return data.access_token;
      }
    }
    return '';

  }
  startInterval () {
    if (!this.loginPollingTimer) {
      this.loginPollingTimer = setInterval(async () => {
        console.log('Polling login status...');
        if (await this.is_logined()) {
          // window.status_notify(1, this.user_info_);
          this.stopInterval();
        }
      }, 3000);
    }
  }
  stopInterval () {
    clearInterval(this.loginPollingTimer);
    this.loginPollingTimer = null;
  }
}

function createAccount (func) {
  return new Account(func);
}

export const account = createAccount(onAccountEvent);

/**
 * @description: 挂在回调，但是页面切换时会丢失回调，需要在页面初始化时再次执行statusNnotify --- api
 */
export function onAccountEvent (state, userInfo) {
  if (state) {
    //  解决初始化页面且有登录态时自动跳转问题
    getToken(isInit);
    isInit = false
  } else {
    store.commit('SET_TOKEN', null)
    store.commit('SET_USER_INFO', null)
    store.commit('SET_CUR_BEFORE_TASK', null)
    store.commit('DEL_CUR_PRINTER')
    store.commit('DEL_CLOUD_PRINTER_LIST')
  }/*  */
  setUserLogin(state, userInfo);
  if (userInfo) {
    store.dispatch('SET_USER_INFO', JSON.parse(userInfo))
  }
}
/**
 * @description: 获取token
 */
function getToken (flag) {
  account.user_token(1).then((token) => {
    store.commit('SET_TOKEN', token)
    if (flag) return false
    router.push('/')
  });
}
/**
 * @description: 获取UserInfo
 */
function getUserInfo () {
  account.user_info().then((res) => {
    store.commit('SET_USER_INFO', JSON.parse(res))
  });
}
export async function getInitUserInfo () {
  const res = await accountSender.get('logged', { 'token': 3 })
  return res.data
}
export async function getIsLogin () {
  if (!account) return false
  const res = await account.user_info()
  return res
}
/**
 * @description: 是否已登录
 */
export function getLogin (flag) {
  account.status_notify(onAccountEvent);
  account.startInterval();
  return account.is_logined().then(res => {
    if (res) {
      getToken(flag);
      getUserInfo();
    } else {
      store.commit('SET_TOKEN', null)
      store.commit('SET_USER_INFO', null)
      store.commit('SET_CUR_BEFORE_TASK', null)
      store.commit('DEL_CUR_PRINTER')
      store.commit('DEL_CLOUD_PRINTER_LIST')
    }
  })
}
